import { render, staticRenderFns } from "./changeDialog.vue?vue&type=template&id=5a445c4e&scoped=true&"
import script from "./changeDialog.vue?vue&type=script&lang=js&"
export * from "./changeDialog.vue?vue&type=script&lang=js&"
import style0 from "./changeDialog.vue?vue&type=style&index=0&id=5a445c4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a445c4e",
  null
  
)

export default component.exports